module.exports = __webpack_public_path__ + "static/media/africa's-talking-sms-logo.3ec806ca.png";